import { Component, EventEmitter, Output } from "@angular/core";
import { IPerson } from "src/app/interfaces";
import { LogClass, Logger } from "src/app/logger";

@LogClass({ source: "Substitute Admin edit" })
@Component({
    selector: "substitute-admin-new",
    templateUrl: "./admin-new.component.html",
    standalone: false
})
export class AdminNewComponent {
  private logger: Logger;
  public person: IPerson[] = [];

  @Output() editClick = new EventEmitter<IPerson>();

  public onClick() {
    this.editClick.emit(this.person[0]);
  }
}
